import { useEffect, useLocation } from 'hooks'

export default function ScrollResetter() {
  const { pathname, search } = useLocation()

  useEffect(() => {
    /myprofile/.test(pathname) || window.scrollTo(0, 0)
  }, [pathname, search])

  return null
}
